






















import { defineProps } from "@vue/runtime-dom";
import { computed } from "@vue/composition-api";
interface Props {
  place: number;
}
const __sfc_main = {};
__sfc_main.props = {
  place: {
    key: "place",
    required: true,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const text = computed(() => props.place === 1 ? "don" : props.place === 2 ? "sotto-capo" : "consigliere");
  const present = computed(() => props.place === 1 ? "5k" : props.place === 2 ? "3k" : "1.5k");
  const presentWidth = computed(() => props.place === 1 ? "clamp(5.625rem, 1.4583rem + 5.5556vw, 8.125rem)" /*130*/ : "clamp(4.6875rem, 1.0417rem + 4.8611vw, 6.875rem)" /* 110 */);
  function formatWithZero(item: number) {
    return item.toString().padStart(2, "0");
  }
  function imgBySubPlace() {
    return require(`@/assets/Competition/Raffle/left-section/banner-${present.value}.svg`);
  }
  return {
    text,
    presentWidth,
    formatWithZero,
    imgBySubPlace
  };
};
export default __sfc_main;
